import React from 'react';
import type { BidTableRowType } from '@/components/Table/BidTableRow';
import BidTableRow from '@/components/Table/BidTableRow';
import DealTableRow from '@/components/Table/DealTableRow';
import { EmptyBidCard } from '@/components/cards/EmptyBidCard';
import LoadingView from '@/components/layout/LoadingView';
import type { DealFragment } from '@/utilities/__generated__/graphql';

const DealTable = ({
  deals,
  heading = 'All Opportunities',
  bids,
  authed = false,
  emptyHasButton,
  emptyButtonPath,
  emptyButtonText,
  emptyCardText,
  filters = null,
  isLoading,
}: {
  heading?: string | null;
  deals?: DealFragment[];
  bids?: BidTableRowType[];
  authed?: boolean;
  emptyHasButton?: boolean;
  emptyButtonPath?: string;
  emptyButtonText?: string;
  emptyCardText?: string;
  filters?: React.ReactNode;
  isLoading?: boolean;
}) => {
  return (
    <div className="mx-auto flex w-full flex-col text-center">
      {/* TODO: Do we need this check? */}
      {deals && heading !== '' && (
        <div className="mx-auto flex h-full w-full flex-col justify-between gap-4 pb-4 md:flex-row md:items-center md:gap-2 md:pb-6">
          <div className="px-0 py-0 text-left font-gt-haptik text-heading-5-mobile font-bold text-black md:px-3 md:text-heading-5">
            {heading}
          </div>
          {filters}
        </div>
      )}
      {isLoading ? (
        <LoadingView />
      ) : deals?.length || bids?.length ? (
        <>
          <div className="grid w-full grid-cols-8 px-0 pb-4 text-neutral-50 md:grid-cols-12 md:px-4">
            <div
              className={`text-grey text-xs ${
                deals
                  ? 'col-span-4 md:col-span-6 lg:col-span-4'
                  : 'col-span-4 md:col-span-6 lg:col-span-4'
              } text-left md:text-sm`}
            >
              Opportunity
            </div>
            <div
              className={`text-grey text-xs col-span-4 text-right md:col-span-5 lg:col-span-3 ${
                deals ? '' : ''
              } md:text-left md:text-sm`}
            >
              {deals ? 'Eligible Collections' : 'Proposed'}
            </div>
            <div
              className={`text-grey text-xs col-span-2 hidden justify-start px-0 text-left ${
                deals ? 'lg:flex' : 'lg:flex'
              } md:text-sm`}
            >
              {deals
                ? 'Est. Budget Per Asset'
                : authed
                ? 'Proposed Amount'
                : ''}
            </div>
            <div className="text-grey text-xs col-span-2 hidden justify-start text-left md:text-sm lg:flex ">
              Submission Deadline
            </div>
          </div>
          {deals &&
            deals.map((deal: DealFragment) => {
              return <DealTableRow key={deal.id} deal={deal} />;
            })}
          {bids &&
            bids.map((bid: BidTableRowType) => {
              return <BidTableRow key={bid.id} deal={bid} />;
            })}
        </>
      ) : (
        <EmptyBidCard
          hasButton={emptyHasButton}
          buttonPath={emptyButtonPath}
          buttonText={emptyButtonText}
          title={emptyCardText}
        />
      )}
    </div>
  );
};
export default DealTable;
